import { createReducer, on } from '@ngrx/store';

import * as fromPersistedStateActions from '../actions/persisted-state.actions';
import * as fromSettingActions from '../actions/setting.actions';
import * as fromUserActions from '../actions/user.actions';

export const userFeatureKey = 'user';

export interface State {
  company: string | null;
  email: string | null;
  farmAlertsEmailNotifications: boolean;
  farmAlertsPushNotifications: boolean;
  firstName: string | null;
  id: string | null;
  lastName: string | null;
  loaded: boolean;
  phone: string | null;
  subscribeToFarmAlerts: boolean;
  username: string | null;
}

export const initialState: State = {
  company: null,
  email: null,
  farmAlertsEmailNotifications: false,
  farmAlertsPushNotifications: false,
  firstName: null,
  id: null,
  lastName: null,
  loaded: false,
  phone: null,
  subscribeToFarmAlerts: false,
  username: null
};

export const reducer = createReducer(
  initialState,
  on(fromSettingActions.loadSettings, () => ({
    ...initialState
  })),
  on(fromUserActions.registerMobileUserSuccess, (state, { payload }) => ({
    ...state,
    ...{
      id: payload.id
    }
  })),
  on(
    fromUserActions.loadMobileUserSuccess,
    fromPersistedStateActions.migratePersistedOldStateUserDataSuccess,
    (state, { payload }) => ({
      ...state,
      ...{
        company: payload.data.company,
        email: payload.data.email,
        farmAlertsEmailNotifications: payload.data.farmAlertEmailNotifications,
        farmAlertsPushNotifications: payload.data.farmAlertPushNotifications,
        firstName: payload.data.firstName,
        id: payload.id,
        lastName: payload.data.lastName,
        loaded: true,
        phone: payload.data.phoneNumber,
        subscribeToFarmAlerts: payload.data.subscribeToFarmAlerts,
        username: payload.data.username
      }
    })
  ),
  on(fromUserActions.loadMobileUserFailure, (state) => ({
    ...state,
    ...{
      loaded: false
    }
  })),
  on(fromUserActions.loadEndUserDetailsSuccess, (state, { payload }) => ({
    ...state,
    company: payload.company,
    email: payload.email,
    firstName: payload.firstName,
    lastName: payload.lastName,
    phone: payload.phone
  })),
  on(fromPersistedStateActions.loadPersistedStateFailure, fromPersistedStateActions.persistedStateReset, () => ({
    ...initialState
  })),
  on(fromPersistedStateActions.loadPersistedStateSuccess, (state, { payload }) => ({
    ...state,
    ...payload[userFeatureKey]
  }))
);
